import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { getLeaveSummaryEmployeeLastYear, getLeaveAwardedThisYear, getListsBeforeForfeit } from "../3.Store/LeaveAccrualYearEndSlice";
import { getLeaveSummaryEmployeeYear } from "../3.Store/EmployeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import { getLeaveBalances } from "../3.Store/ApplicationSlice";

const FooterMenu = () => {
  const dispatch = useDispatch();
  const summariesLastYear = useSelector(state => state.LeaveAccrualYearEndSlice.summaries);
  const summary = useSelector((state) => state.EmployeeSlice.summaries);
  const awarded = useSelector(state => state.LeaveAccrualYearEndSlice.awarded);
  const bfForfeit = useSelector(state => state.LeaveAccrualYearEndSlice.bfForfeit);
  const lastYear = moment().subtract(1, 'year').format('YYYY');
  const [excessLeave, setexcessLeave] = useState();
  const balance = useSelector(state => state.ApplicationSlice.balance);

  const roles = JSON.parse(localStorage.getItem("roles"));
  const user = JSON.parse(localStorage.getItem("current_user"));
  const name = user?.fullname;

  useEffect(() => {
    if(name) {
      dispatch(getLeaveBalances({ id: user.id }));
      dispatch(getLeaveSummaryEmployeeLastYear({id: user.id, year: lastYear}));
      dispatch(getLeaveAwardedThisYear({id: user.id, year: moment().format('YYYY')}));
      dispatch(getLeaveSummaryEmployeeYear({ id: user.id, year: moment().format('YYYY') }));
      dispatch(getListsBeforeForfeit({id: user.id, year: moment().format('YYYY')}))
        .then(() => {
        })
        .catch(() => {
        });
    };
  }, [name]);

  useEffect(() => {
    // Calculation
    const leaveEntitlement = Number(awarded?.annual) || 0;
    const leaveBalanceLastYear = Number(summary[0]?.ob) || 0;
    const leaveBalanceThisYear = Number(balance?.annual) || 0;

    const leaveUtilized = leaveEntitlement + leaveBalanceLastYear - leaveBalanceThisYear;
    const exLeave = leaveBalanceThisYear - 5;

    const gender = awarded?.employee?.gender;
    const dateJoined = moment(awarded?.employee?.date_joined);

    const leaveData = {
      leaveEntitlement,
      leaveBalanceLastYear,
      leaveBalanceThisYear,
      leaveUtilized,
      // excessLeave: 7,
      excessLeave: exLeave > 0 ? exLeave : 0,
      gender,
      dateJoined
    };
  
    // store as JSON in localStorage
    localStorage.setItem("leaveData", JSON.stringify(leaveData));

    if (exLeave <= 0) {
      setexcessLeave(0);
    }
    else {
      setexcessLeave(exLeave);
    }

    // setexcessLeave(7);
  }, [summariesLastYear, awarded, bfForfeit])

  console.log("Leave Excess:", excessLeave);

  const linkStyle = {
    color: '#ADADAD',
    fontSize: '1.125rem',
    fontWeight: 400,
    textDecoration: 'none',
  };  

  return (
    <Container fluid className="bg-black text-light" style={{ marginTop: '30px', opacity: 0.8, minHeight: '400px' }}>
      <Row className="mt-5 px-5 justify-content-center">

        <Col sm={6} md={2} lg={2} className="mx-5 text-center text-md-start">
          <h2 className="text-white mb-2">Menu</h2>
          <ul className="list-unstyled mb-2">
            <li>
              <a className="text-decoration-none" style={linkStyle} href="/LeaveApplicationList">
                 Leave Applications
              </a>
            </li>
            <li>
              <a className="text-decoration-none" style={linkStyle} href="/Holidays">
                Holidays
              </a>
            </li>
            <li>
              <a className="text-decoration-none" style={linkStyle} href="/StaffInformations">
                Staff Informations
              </a>
            </li>
            <li>
              <a className="text-decoration-none" style={linkStyle} href="/StaffOnLeave">
                Staff on Leave
              </a>
            </li>
            <li>
              <a className="text-decoration-none" style={linkStyle} href="/LeaveReportList">
                Leave Movement Records
              </a>
            </li>
            {/* {excessLeave > 5 && (
              <li>
                <a className="text-decoration-none" style={linkStyle} href="/LeaveAccrualYearEndList">
                  Leave Accrual
                </a>
                &nbsp;
                <span>
                  <FontAwesomeIcon icon={faExclamationCircle} style={{color: "#f22c2c", fontSize: "20px"}} />
                </span>
              </li>
            )} */}
          </ul>

          <br></br>

          {Array.isArray(roles) && roles.some(role => ['SU-L-APPROVAL', 'SU-M-BENEFIT'].includes(role)) && (
            <>
              <h2 className="text-white mb-2">Supervisor</h2>

              <ul className="list-unstyled mb-4">

              {roles?.includes('SU-L-APPROVAL') && (
                <li>
                  <a className="text-decoration-none" style={linkStyle} href="/LeaveApprovalList">
                    Supervisor Leave Approval
                  </a>
                </li>
              )}

              {roles?.includes('SU-M-BENEFIT') && (
                <li>
                  <a className="text-decoration-none" style={linkStyle} href="/SUReviewClaimList">
                    Supervisor Review Claim
                  </a>
                </li>
              )}

              {roles?.includes('SU-L-APPROVAL') && (
                <li>
                  <a className="text-decoration-none" style={linkStyle} href="/SULeaveSummaryList">
                    Leave Summary
                  </a>
                </li>
              )}
              </ul>
            </>
          )}
        </Col>

        {roles?.includes('HR-L-SUMMARY') && (
          <Col sm={6} md={2} lg={2} className="mx-5 text-center text-md-start">

            <h2 className="text-white mb-2">Human Resources</h2>

            {/* GROUP 1 */}
            {(roles?.includes('HR-EMP-MGT') ||
              roles?.includes('HR-EMP-PRO-MGT') ||
              roles?.includes('HR-SU-TRANS') ||
              roles?.includes('HR-L-APPLY') ||
              roles?.includes('HR-L-WITHDRAWN') ||
              roles?.includes('HR-M-APPLY') ||
              roles?.includes('HR-L-SUMMARY')) && (
              <div className="mb-3">
                <ul className="list-unstyled">
                  {roles?.includes('HR-EMP-MGT') && (
                    <li><a style={linkStyle} href="/EmployeeList">Employees</a></li>
                  )}
                  {roles?.includes('HR-EMP-PRO-MGT') && (
                    <li><a style={linkStyle} href="/EmployeeProbationList">Employees Under Probation</a></li>
                  )}
                  {roles?.includes('HR-SU-TRANS') && (
                    <li><a style={linkStyle} href="/SupervisorStaffManagementList">Supervisor Transfers</a></li>
                  )}
                  {roles?.includes('HR-L-APPLY') && (
                    <li><a style={linkStyle} href="/HRLeaveApplication">Leave Application</a></li>
                  )}
                  {roles?.includes('HR-L-WITHDRAWN') && (
                    <li><a style={linkStyle} href="/LeaveWithdrawalList">Leave Withdrawals</a></li>
                  )}
                  {roles?.includes('HR-M-APPLY') && (
                    <li><a style={linkStyle} href="/HRMedicalClaimApplicationForm">Medical Claim Application</a></li>
                  )}
                  {roles?.includes('HR-L-SUMMARY') && (
                    <li><a style={linkStyle} href="/LeaveSummaryList">Leave Summary</a></li>
                  )}
                </ul>
              </div>
            )}

            {/* GROUP 2 */}
            {(roles?.includes('HR-L-APPROVAL') ||
              roles?.includes('HR-M-BENEFIT')) && (
              <div className="mb-3">
                <ul className="list-unstyled">
                  {roles?.includes('HR-L-APPROVAL') && (
                    <li><a style={linkStyle} href="/ReviewLeaveList">Review Leave Applications</a></li>
                  )}
                  {roles?.includes('HR-M-BENEFIT') && (
                    <li><a style={linkStyle} href="/HRReviewMedicalList">Review Medical Claims</a></li>
                  )}
                </ul>
              </div>
            )}

            {/* GROUP 3 */}
            {(roles?.includes('HR-L-AWARD') ||
              roles?.includes('HR-L-ACCRUAL') ||
              roles?.includes('HR-L-PRORATED')) && (
              <div className="mb-3">
                <ul className="list-unstyled">
                  {roles?.includes('HR-L-AWARD') && (
                    <li><a style={linkStyle} href="/LeaveAwardList">Leave Awards</a></li>
                  )}
                  {roles?.includes('HR-L-ACCRUAL') && (
                    <li><a style={linkStyle} href="/LeaveAccrualList">Leave Accruals</a></li>
                  )}
                  {roles?.includes('HR-L-PRORATED') && (
                    <li><a style={linkStyle} href="/LeaveProratedList">Leave Prorates</a></li>
                  )}
                </ul>
              </div>
            )}

            {/* GROUP 4 */}
            {roles?.includes('HR-USER-ACCESS') && (
              <div className="mb-3">
                <ul className="list-unstyled">
                  <li><a style={linkStyle} href="/UserAccessList">User Access</a></li>
                </ul>
              </div>
            )}

            {/* GROUP 5 */}
            {roles?.includes('HR-USER-ACCESS') && (
              <div className="mb-3">
                <ul className="list-unstyled">
                  <li><a style={linkStyle} href="/Entitlement">Leave Entitlements</a></li>
                  <li><a style={linkStyle} href="/Company">Companies</a></li>
                  <li><a style={linkStyle} href="/Site">Sites</a></li>
                </ul>
              </div>
            )}

            {/* BOTTOM ALWAYS SHOW */}
            {/* <ul className="list-unstyled">
              <li><a style={linkStyle} href="/StaffOnLeave">Staff on Leave</a></li>
              {roles?.includes('HR-HOLIDAY') && (
                <li><a style={linkStyle} href="/Holidays">Holidays</a></li>
              )}
            </ul> */}

          </Col>
        )}

        <Col sm={6} md={3} lg={3} className="mx-5 text-center text-md-start">
          <h2 className="text-white mb-2">Hock Seng Lee Berhad</h2>
          <p style={linkStyle}>
            No 1, HSL Tower,
            <br />
            Lorong La Promenade 2, Kuching-Samarahan Expressway,
            <br />
            94300 Samarahan, Sarawak, Malaysia.
          </p>
        </Col>

      </Row>

      <Row className="py-4 px-5 justify-content-center">
        <Col className="text-center">
          <p style={{ color: 'rgba(255, 255, 255, 0.47)', fontSize: '0.85rem', fontWeight: 400 }}>
            Build 1.1 (5 May 2026)
          </p>
        </Col>
      </Row>
    </Container>
  );
};
export default FooterMenu;